<template>
  <div id="share-report" :style="{ background: $util.srBackground(grade) }" v-if="isShow">
    <div id="report-top">
      <div class="title">
        <p class="title-zh" :style="{ color: $util.srTitle(grade) }">瑞思阶段性评估报告</p>
        <p class="title-en" :style="{ color: $util.srTitle(grade)}">Stage Assessment Report Of RISE</p>
      </div>
      <img
        class="title-banner"
        :src="require('../assets/imgs/'+ grade +'/level-card-banner2.png')"
        alt
      />
      <div
        class="title-medal-div"
        :style="{ backgroundImage: 'url('+ require('../assets/imgs/'+ grade +'/medal1.png') +')'}"
      >
        <!--<img class="title-medal" :src="require('../assets/imgs/'+ grade +'/medal1.png')" alt="">-->
        <!-- <span v-if="data.level!=='Try Harder'" class="title-level">{{data.level}}</span>
        <span v-else class="title-level" style="font-size: 1em;margin-top: 3.8rem;">{{data.level}}</span>-->
        <span
          v-if="data.level!=='Try Harder'&&data.level!=='A+'"
          id="level-card-text"
        >{{data.level}}</span>
        <span
          v-if="data.level==='A+'"
          class="title-level"
          style="font-size: 3em;margin-top: 2.5rem;"
        >{{data.level}}</span>
        <span
          v-if="data.level==='Try Harder'"
          class="title-level"
          style="font-size: 1em;margin-top: 3.8rem;"
        >{{data.level}}</span>
      </div>
      <BeyondCard
        :name="data.name"
        :beyond="data.beyond"
        :beyondIndex="data.beyondIndex"
        :test-date="data.testDate"
        :test-inner="data.testInner"
        :grade="grade"
      ></BeyondCard>
    </div>
    <div id="report-mid">
      <span class="circle top-left-circle" :style="{ backgroundColor: $util.srCircle(grade) }"></span>
      <span class="circle top-right-circle" :style="{ backgroundColor: $util.srCircle(grade) }"></span>
      <span class="circle bottom-left-circle" :style="{ backgroundColor: $util.srCircle(grade) }"></span>
      <span class="circle bottom-right-circle" :style="{ backgroundColor: $util.srCircle(grade) }"></span>
      <img class="mid-medal" :src="require('../assets/imgs/'+ grade +'/medal2.png')" alt />
      <div class="mid-info">
        <p class="normal-text">Hi，大家好</p>
        <p class="normal-text">我是瑞思{{data.grade}}阶段在读学员</p>
        <p class="height-light-text" :style="{ color: $util.srText(grade) }">
          {{data.name}}
          <span v-if="data.enName">（{{data.enName}}）</span>
        </p>
        <p class="normal-text">在瑞思学习已经超过</p>
        <p class="height-light-text" :style="{ color: $util.srText(grade) }">{{data.ks}}课时</p>
        <p class="normal-text">这是瑞思{{data.grade}}阶段的</p>
        <p class="height-light-text mb40" :style="{ color: $util.srText(grade) }">第{{data.time}}次</p>
        <p class="normal-text">全英文评估测试</p>
      </div>
      <div class="mid-card-ctx" :style="{ borderColor: $util.borderColor(grade) }">
        <img :src="require('../assets/imgs/'+ grade +'/top-left-1.png')" alt id="top-left" />
        <img :src="require('../assets/imgs/'+ grade +'/top-right-1.png')" alt id="top-right" />
        <img :src="require('../assets/imgs/'+ grade +'/bottom-left-1.png')" alt id="bottom-left" />
        <img :src="require('../assets/imgs/'+ grade +'/bottom-right-1.png')" alt id="bottom-right" />
        <p v-html="data.text"></p>
      </div>
      <div class="mid-compare">
        <img :src="data.compareImgUrl" alt />
      </div>
      <div
        v-if="data.videoStatus&&data.audioUrl!==''"
        @click="startMp3"
        class="mid-audio"
        :style="{ color: $util.srButtonText(grade), backgroundColor: $util.srButton(grade), boxShadow: $util.srButtonShadow(grade)}"
      >
        <b-icon name="laba" :size="2" :color="$util.srButtonText(grade)"></b-icon>点击听听我的精彩表现
      </div>
      <div>
        <audio id="mp3" :src="data.audioUrl"></audio>
      </div>
    </div>
  </div>
</template>
<script>
import BeyondCard from "@/common/BeyondCard";
export default {
  components: {
    BeyondCard
  },
  props: {
    testId: {},
    grade: {
      default: 6
    }
  },
  data() {
    return {
      isShow: false,
      data: {
        level: "A",
        grade: "K1",
        name: "庄晓曼",
        enName: "Zhuang",
        beyond: 0,
        testDate: "2019-09-21",
        testInner: "K1,120-200课时",
        ks: "48",
        time: "一",
        text: "",
        compareImgUrl: "",
        audioUrl: "",
        videoStatus: null
      }
    };
  },
  created() {
    this.fetch();
  },
  mounted() {},
  methods: {
    fetch() {
      this.$http(`student-base/${this.testId}/${this.grade}`)
        .then(res => {
          this.data = res.data;
          this.data.text = (this.data.text + "").replace(/\n/g, "<br/>");
          console.log(this.data.text);
          this.isShow = true;
        })
        .catch(err => {
          alert(err + "当前接口暂时无法访问");
        });
    },
    startMp3() {
      console.log(111);
      let au = document.getElementById("mp3");
      au.currentTime = 0;
      au.play();
    }
  }
};
</script>
<style lang="scss" scoped>
#share-report {
  width: 100%;
  overflow-y: scroll;
  padding-bottom: 100px;
  #report-top {
    position: relative;
    width: 100%;
    min-height: 1920px;
    .title {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 20;
      margin: 5%;
      .title-zh {
        color: #9d6738;
        font-size: 115px;
      }
      .title-en {
        font-size: 65px;
        font-weight: 300;
        letter-spacing: 3px;
        color: #9d6738;
        font-family: Source Han Sans CN, Helvetica Neue, Helvetica, Arial,
          sans-serif;
      }
    }
    .title-banner {
      width: 100%;
      position: absolute;
      top: 0;
      z-index: 5;
    }
    .title-medal-div {
      display: flex;
      position: absolute;
      top: 120px;
      right: 6.5%;
      justify-content: center;
      z-index: 30;
      width: 800px;
      height: 820px;
      background-size: 800px;
      .title-medal {
        width: 100%;
      }
      .title-level {
        margin-top: 150px;
        font-size: 4rem;
        font-weight: bold;
        color: #fff;
        text-shadow: 1px 1px 2px #ef9305;
      }
    }

    #level-card-inner {
      -webkit-box-shadow: 1px 1px 20px -13px #000;
      -moz-box-shadow: 1px 1px 20px -13px #000;
      box-shadow: 1px 1px 20px -13px #000;
    }
  }
  #report-mid {
    width: 90%;
    position: relative;
    background: #fff;
    margin: 0 auto;
    margin-top: 200px;
    padding-top: 750px;
    padding-bottom: 150px;
    border-radius: 40px;
    .circle {
      display: inline-block;
      position: absolute;
      width: 60px;
      height: 60px;
      border-radius: 100%;
      background: #eea221;
    }
    .top-left-circle {
      top: 60px;
      left: 60px;
    }
    .top-right-circle {
      top: 60px;
      right: 60px;
    }
    .bottom-left-circle {
      bottom: 60px;
      left: 60px;
    }
    .bottom-right-circle {
      bottom: 60px;
      right: 60px;
    }
    .mid-medal {
      position: absolute;
      top: -150px;
      left: 50%;
      transform: translateX(-50%);
      width: 700px;
    }
    .mid-info {
      text-align: center;
      .normal-text {
        font-size: 85px;
        letter-spacing: 8px;
        margin-bottom: 40px;
        &:last-child {
          margin-bottom: 0;
        }
      }
      .height-light-text {
        font-size: 120px;
        margin-bottom: 90px;
        color: #f9bf2f;
        font-weight: bold;
      }
      .mb40 {
        margin-bottom: 20px;
      }
    }
    .mid-card-ctx {
      position: relative;
      padding: 5%;
      margin: 0 auto;
      color: #666;
      margin-top: 150px;
      border: 30px solid #fff0c0;
      border-radius: 20px;
      width: 90%;
      min-height: 800px;
    }
    .mid-compare {
      width: 90%;
      margin: 100px auto;
      img {
        width: 100%;
      }
    }
    .mid-audio {
      width: 65%;
      font-size: 90px;
      font-weight: bold;
      color: #d9781f;
      margin: 0 auto;
      padding: 50px;
      background-color: #fabf2e;
      border-radius: 130px;
      display: flex;
      align-items: center;
      justify-content: center;
      -webkit-box-shadow: 0 3px 0 0 #de7f1e;
      -moz-box-shadow: 0 3px 0 0 #de7f1e;
      box-shadow: 0 3px 0 0 #de7f1e;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ShareReport.vue